<template>
  <div :class="{'emi-index-contact-box': true, 'mobile': isMobile}">
    <h1 class="contact-box-title"> 留下您的联系方式，营销顾问会尽快与您联络</h1>
    <el-form :model="formData" ref="form" :rules="rules" label-position="top" class="contact-form">
      <div v-for="item in formItems" :key="item.label" :class="{'contact-form-item': true, 'large': item.large}">
        <el-form-item :label="item.name" :prop="item.label" :required="item.required" :class="item.label">
          <el-input v-if="item.type === 'input'" v-model="formData[item.label]">
            <el-button v-if="item.label == 'telPhoneCode'" slot="append" :disabled="time > 0" @click="getVerifyCode"> {{verifyCodeText}}</el-button>
          </el-input>
          <el-select v-else v-model="formData[item.label]" style="width: 100%;">
            <el-option v-for="op in item.options" :value="op" :label="op" :key="op"></el-option>
          </el-select>
        </el-form-item>
      </div>
    </el-form>
    <div class="form-action">
      <button class="contact-form-submit" @click="submit"> 完成并提交</button>
    </div>
  </div>
</template>
<script>
  import axios from '../common/axios.js';
  export default {
    name: 'contact',
    data() {
      return {
        formItems: [
          {name: '姓名', required: true, large: false, label: 'contractName', type: 'input'},
          {name: '手机', required: true, large: false, label: 'telPhoneNum', type: 'input'},
          {name: '手机验证码', required: true, large: false, label: 'telPhoneCode', type: 'input'},
          {name: '公司名称', required: true, large: false, label: 'companyName', type: 'input'},
          {name: '公司所在地', required: true, large: false, label: 'province', type: 'select', options: ['安徽', '北京', '重庆', '福建', '甘肃', '广东', '广西', '贵州', '海南', '河北', '黑龙江', '河南', '湖北', '湖南', '江苏', '江西', '吉林', '辽宁', '内蒙古', '宁夏', '青海', '山东', '上海', '山西', '陕西', '四川', '天津', '新疆', '西藏', '云南', '浙江', '台湾', '香港', '澳门']},
          {name: '公司所属行业', required: true, large: false, label: 'industry', type: 'select', options: []},
          {name: '公司网址', required: false, large: false, label: 'website', type: 'input'},
          {name: '电子邮箱', required: false, large: false, label: 'email', type: 'input'},
        ],
        formData: {
          contractName: '',
          telPhoneNum: '',
          companyName: '',
          province: '',
          industry: '',
          website: '',
          email: ''
        },
        rules: {
          contractName: {
            required: true,
            message: '请输入姓名'
          },
          telPhoneNum: {
            required: true,
            validator: (rule, value, callback) => {
              if (!/^1[3456789]\d{9}$/.test(value)) {
                callback(new Error('请输入正确的手机号码'));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          },
          telPhoneCode: {
            required: true,
            message: '请输入手机号验证码'
          },
          companyName: {
            required: true,
            message: '请输入公司名称'
          },
          province: {
            required: true,
            message: '请选择公司所在地'
          },
          industry: {
            required: true,
            message: '请选择公司所属行业'
          }
        },
        time: 0,
        isMobile: /iPhone|Android/ig.test(navigator.userAgent)
      }
    },
    computed: {
      verifyCodeText() {
        return this.time > 0 ? `重新发送(${this.time}s)` : '发送验证码';
      }
    },
    created() {
      this.getIndustry();
    },
    methods: {
      async getVerifyCode() {
        if (this.time > 0 || !/^1[3456789]\d{9}$/.test(this.formData.telPhoneNum)) {
          return;
        }
        try {
          const res = await axios({
            url: '/account/textMessage/sendCode',
            method: 'get',
            params: {
              telPhoneNum: this.formData.telPhoneNum
            }
          });
          this.handleResult(res);
          
        } catch (e) {
          this.handleResult(e)
        }
      },
      handleResult(res) {
        if (res.success) {
          this.$message({
            message: '短信验证码已发送，有效期5分钟',
            type: 'success'
          });
          this.time = 120;
          let timer = setInterval(() => {
            this.time--;
            if (this.time <= 0) {
              clearInterval(timer);
              this.time = 0;
            }
          }, 1000);
        } else {
          this.$message({
            message: res.code == 0 ? '验证码发送失败' : res.failMsg || '无效的手机号码',
            type: 'error'
          });
        }
      },
      async submit() {
        try {
          await this.$refs.form.validate();
          let res = await axios({
            url: '/account/coreAgentPublicity/publicityMessage',
            method: 'post',
            data: this.formData
          });
          if (res.success) {
            this.$message({
              message: res.result,
              type: 'success'
            });
            Object.keys(this.formData).forEach(key => {
              this.formData[key] = '';
            });
            this.$refs.form.resetFields();
          }
        } catch(err) {
          if (err) {
            this.$message({
              message: err.failMsg || '提交失败，请稍后再试' ,
              type: 'error'
            });
          }
        }
      },
      async getIndustry() {
        try {
          let res = await axios({
            url: '/v2/account/profile/industryLevel'
          });
          if (res.success && res.result) {
            let industry = this.formItems.find(item => item.label === 'industry');
            industry.options = res.result.map(op => op.name);
          }
        } catch (err) {
          console.log(err);
        }
      }
    }
  }
</script>